import { render, staticRenderFns } from "./StudentPhoneAttach.vue?vue&type=template&id=758ffeee&scoped=true&"
import script from "./StudentPhoneAttach.vue?vue&type=script&lang=js&"
export * from "./StudentPhoneAttach.vue?vue&type=script&lang=js&"
import style0 from "./StudentPhoneAttach.vue?vue&type=style&index=0&id=758ffeee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758ffeee",
  null
  
)

export default component.exports